import React from "react";

// Surface container used for auth forms and content panels.
export default function Card({ className = "", children }) {
  return (
    <div
      className={`w-full rounded-2xl border border-white/10 bg-navy-700/80 p-8 shadow-card backdrop-blur-sm ${className}`}
    >
      {children}
    </div>
  );
}
